module.exports = __webpack_public_path__ + "static/img/iconBlue.3287c079.png";